import { createFileRoute } from '@tanstack/react-router'

import SearchProductsPage from '@/layouts/themes/antau/pages/search'

export const Route = createFileRoute('/_layout/search')({
  component: SearchProductsPage,
})
